import { cn } from 'components/UI/cn'

export function AccountCard({
  value,
  label,
  className,
}: {
  value?: string
  label: string
  className?: string
}) {
  return (
    <div
      className={cn(
        'border-1 border-[#B9C0D4] rounded-xl px-3 py-3 mr-6 w-40',
        className
      )}
    >
      <h2 className="text-md mb-2 text-gray-600">{label}</h2>
      <p className="text-gray-900 text-xl font-semibold">
        {value ? value : '-'}
      </p>
    </div>
  )
}
